import { VIEWER_SET_SHOW_CENTERLINE_BOUNDS_WARNING } from '../actions';

export default function setShowCenterlineBoundsWarning(showCenterlineBoundsWarning) {
  return {
    type: VIEWER_SET_SHOW_CENTERLINE_BOUNDS_WARNING,
    showCenterlineBoundsWarning,
  };
}
